"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("../Themes/styled-components"));

var icons_1 = __importDefault(require("./icons"));

var Wrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n"], ["\n  display: inline-flex;\n  align-items: center;\n"])));
var defaultProps = {
  size: 'm'
};

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Icon.prototype.sizeToPx = function (size) {
    var sizeMapping = {
      xs: 8,
      s: 12,
      m: 16,
      l: 24,
      xl: 40,
      xxl: 110
    };
    return size in sizeMapping ? sizeMapping[size] : 16;
  };
  /**
   * Method resolves deprecated names for icons
   */


  Icon.prototype.getName = function (nameFromProps) {
    switch (nameFromProps) {
      case 'remove-smarttag':
        return 'close';

      case 'arrow-down-small':
      case 'chevron':
        return 'arrow-down';

      case 'arrow':
        return 'arrow-right';

      default:
        return nameFromProps;
    }
  };

  Icon.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        color = _a.color,
        className = _a.className,
        nameFromProps = _a.name,
        restProps = __rest(_a, ["size", "color", "className", "name"]);

    var name = this.getName(nameFromProps);
    var iconSize = typeof size === 'string' ? this.sizeToPx(size) : size;
    var iconColor = this.props.color ? color : this.props.theme.textColor;
    return React.createElement(Wrapper, __assign({
      className: "icon " + className
    }, restProps), name in icons_1.default ? icons_1.default[name](iconSize, iconColor) : null);
  };

  Icon.defaultProps = defaultProps;
  return Icon;
}(React.PureComponent);

exports.default = styled_components_1.withTheme(Icon);

var icons_2 = require("./icons");

exports.icons = icons_2.default;
var templateObject_1;